import React from 'react';
import { Outlet } from 'react-router-dom';

import { SUBSCRIBER_PATH } from '../../../../constants';

const OrganizationMembers = React.lazy(() => import('./index'));
const OrgMemberDetails = React.lazy(() => import('./OrgMember/Details'));

const Routes = {
     path: SUBSCRIBER_PATH.ORGANIZATIONS_ORG_MEMBERS,
     breadcrumb: 'Manage Users',
     element: <Outlet />,
     children: [
          { index: true, element: <OrganizationMembers /> },
          {
               path: SUBSCRIBER_PATH.ORGANIZATIONS_ORG_MEMBERS_DETAILS,
               breadcrumb: 'Details',
               element: <OrgMemberDetails />,
          },
     ],
};

export default Routes;
